var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SettingsPanelComponent } from "../settings-panel.component";
var QueueSettingsComponent = /** @class */ (function (_super) {
    __extends(QueueSettingsComponent, _super);
    function QueueSettingsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Save current settings to the server.
     */
    QueueSettingsComponent.prototype.saveSettings = function () {
        var settings = this.state.getModified();
        //need to save pusher key to both .env file and database
        //because it is used on server side and on client side
        if (settings.client['realtime.pusher_key']) {
            settings.server['pusher_key'] = settings.client['realtime.pusher_key'];
        }
        _super.prototype.saveSettings.call(this, settings);
    };
    return QueueSettingsComponent;
}(SettingsPanelComponent));
export { QueueSettingsComponent };
